// Codes of the links to the Keez manual, stored in accounts.application_link (dictionary 'application_link').
// Each code must exist in the table; the url is read from the API at runtime.
export const ApplicationLinkCode = {
	HelpClientIndex: 'help-client-index',
	HelpExpertIndex: 'help-expert-index',
	HelpExpertPayrollIndex: 'help-expert-payroll-index',
	HelpOperatorIndex: 'help-operator-index',

	EFacturaInboxFacturaPrimita: 'efactura-inbox-factura-primita',
	DocumenteFacturiCumparareEFactura: 'documente-facturi-cumparare-efactura',
	UtilizatoriEmailWhitelist: 'utilizatori-email-whitelist',

	M2pAngajat: 'm2p_angajat',
	M2pPlafon: 'm2p_plafon',
	Intreprinderi: 'intreprinderi',
	ImpozitVenit: 'impozit_venit',
	ImpozitProfit: 'impozit_profit',
	Consultanta80: 'consultanta80',

	DuPfaDateContribuabil: 'du-pfa-date-contribuabil',
	DuPfaActivitatiIndependente: 'du-pfa-activitati-independente',
	DuPfaChirii: 'du-pfa-chirii',
	DuPfaDividende: 'du-pfa-dividende',
	DuPfaVenituriStrainatate: 'du-pfa-venituri-strainatate',
	DuPfaEsteAngajat: 'du-pfa-este-angajat',
	DuPfaComentarii: 'du-pfa-comentarii',
	DuPfaOptionalSanatate: 'du-pfa-optional-sanatate',
	DuPfaOptionalPensie: 'du-pfa-optional-pensie',
	DuPfaOng: 'du-pfa-ong',
	DuPfaCompletare: 'du-pfa-completare',

	ContractAbonamentModifica: 'contract-abonament-modifica',
	ContractRezolvaDepasiri: 'contract-rezolva-depasiri',
	ConfigurariPuncteLucru: 'configurari-puncte-lucru',

	ArticoleEdit: 'articole-edit',
	FacturaPrestareFurnizor: 'factura-prestare-furnizor',
	FacturaTvaIncasare: 'factura-tva-incasare',

	SalariatiRegesNivelStudii: 'salariati-reges-nivel-studii',
	SalariatiRegesTimpMunca: 'salariati-reges-timp-munca',
	SalariatiRegesLocMunca: 'salariati-reges-loc-munca',
	SalariatiSalariuMinim: 'salariati-salariu-minim',

	BilanturiLista: 'bilanturi-lista',
	ExpertDeclaratiiConfig: 'expert-declaratii-config',
	ExpertDocumenteActiuni: 'expert-documente-actiuni',
} as const;

export type ApplicationLinkCodeType = typeof ApplicationLinkCode[keyof typeof ApplicationLinkCode];
